export const topLevelDomains = [
  ".co",
  ".com",
  ".net",
  ".org",
  ".us",
  ".io",
  ".me",
  ".edu",
  ".gov",
  ".mil",
  ".info",
  ".biz",
  ".ai",
  ".app",
  ".dev",
];
